/**
 * accountSettingsSlice — Account settings (profile name/email + session timeout).
 *
 * Hydrated from the seed via AccountSettingsInitializer; the form seeds its
 * local fields from here and dispatches `setAccountSettings` on save. Passwords
 * are NOT kept here — they stay transient in the form. Swap the seed for SSR
 * fetchers once the profile / session-timeout endpoints are confirmed.
 */
import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import {
  type AccountSettings,
  defaultAccountSettings,
} from "@/components/settings/account/types";

export interface AccountSettingsState {
  settings: AccountSettings;
  loading: boolean;
}

const initialState: AccountSettingsState = {
  settings: defaultAccountSettings(),
  loading: true,
};

const accountSettingsSlice = createSlice({
  name: "accountSettings",
  initialState,
  reducers: {
    setAccountSettings(state, action: PayloadAction<AccountSettings>) {
      state.settings = action.payload;
    },
    setAccountLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
  },
});

export const { setAccountSettings, setAccountLoading } =
  accountSettingsSlice.actions;

export default accountSettingsSlice.reducer;
